/* eslint-disable sort-keys */
export const perPage = {
  sm: 3,
  md: 12,
};
